import { apiRequest } from "../index";

export const getAllUserWalletSummaries = async ({ page = 1, limit = 10, type }) => {
  const params = new URLSearchParams();
  params.append("page", page);
  params.append("limit", limit);
  params.append("type" , type)

  return apiRequest(`/api/admin/commission/balances`, "GET");
};
